import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { getFieldPath } from "../../Common/SchemaUtils";

const getEnumFormField = (enum_values: string[]) => {
  const EnumFormFields: React.FC<{
    extractionId: string;
    extractionPath?: string;
    label?: string;
  }> = ({ extractionId, extractionPath, label }) => {
    const { control } = useFormContext();
    return (
      <Controller
        render={({ field: { onChange, ...props } }) => (
          <Autocomplete
            options={enum_values}
            renderInput={(params) => (
              <TextField {...params} size="small" label={label} />
            )}
            onChange={(e, lang) => onChange(lang)}
            {...props}
          />
        )}
        name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}`}
        control={control}
      />
    );
  };
  return EnumFormFields;
};

export default getEnumFormField;
